/** Represents the common types of the data. */
export var DataType;
(function (DataType) {
    /** Unknown type value*/
    DataType[DataType["Unknown"] = 0] = "Unknown";
    /** String value*/
    DataType[DataType["String"] = 1] = "String";
    /** 8-bit integer value */
    DataType[DataType["Byte"] = 2] = "Byte";
    /** 16-bit integer value */
    DataType[DataType["Word"] = 3] = "Word";
    /** 32-bit integer value */
    DataType[DataType["Int32"] = 4] = "Int32";
    /** 64-bit integer value */
    DataType[DataType["Int64"] = 5] = "Int64";
    /** Boolean value */
    DataType[DataType["Bool"] = 6] = "Bool";
    /** Floating-point numeric value */
    DataType[DataType["Float"] = 7] = "Float";
    /** Money value */
    DataType[DataType["Currency"] = 8] = "Currency";
    /** Binary-coded decimal value */
    DataType[DataType["BCD"] = 9] = "BCD";
    /** Date value */
    DataType[DataType["Date"] = 10] = "Date";
    /** Time value */
    DataType[DataType["Time"] = 11] = "Time";
    /** Date and time value */
    DataType[DataType["DateTime"] = 12] = "DateTime";
    /** Autoincrement 32-bit integer value */
    DataType[DataType["Autoinc"] = 13] = "Autoinc";
    /** MEMO value (text with unlimited length) */
    DataType[DataType["Memo"] = 14] = "Memo";
    /** BLOB value (any data with unlimited length) */
    DataType[DataType["Blob"] = 15] = "Blob";
    /** Fixed character value */
    DataType[DataType["FixedChar"] = 16] = "FixedChar";
    /** The unique identifier */
    DataType[DataType["Guid"] = 17] = "Guid";
    /*-------- Spatial data types ----------*/
    /** Any geometry data */
    DataType[DataType["Geometry"] = 18] = "Geometry";
    /** Any data that represents some geography objects</summary> */
    DataType[DataType["Geography"] = 19] = "Geography";
})(DataType || (DataType = {}));
//# sourceMappingURL=data_type.js.map